/**
 * The single shared TanStack Query client. Imported by the provider
 * and by the router context (so loaders can prefetch/read the cache).
 */
import { QueryClient } from '@tanstack/react-query'
import { QUERY_DEFAULTS } from '@/config/app.config'
import { ApiError } from '@/lib/api'

/** HTTP statuses that should never be retried. */
const NO_RETRY_STATUSES = new Set([400, 401, 403, 404, 422])

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: QUERY_DEFAULTS.staleTime,
      gcTime: QUERY_DEFAULTS.gcTime,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && NO_RETRY_STATUSES.has(error.status)) {
          return false
        }
        return failureCount < QUERY_DEFAULTS.retry
      },
    },
    mutations: {
      retry: 0,
    },
  },
})
